<!-- ── NEW REQUEST footer ──────────────────────────────────────────────── -->
<div class="modal-footer" *ngIf="mode === 'NEW_REQUEST'">
    <div *ngIf="!working">
        <div
            *ngIf="
                formValid &&
                ((errorMessage != null && errorMessage.length > 0) ||
                    authorisationForm?.value?.hasRemainingValidationErrors)
            "
            class="alert alert-danger footer-alert pull-left"
            role="alert"
        >
            <p>
                <span class="fa fa-times right-buffer"></span>
                The Automated Authorisation Request is invalid:
                {{ errorMessage }}
            </p>
        </div>
        <div
            *ngIf="!formValid"
            class="alert alert-danger footer-alert pull-left"
            role="alert"
        >
            <p>
                <span class="fa fa-times right-buffer"></span>
                The Automated Authorisation Request is incomplete and cannot be
                submitted{{
                    authorisationForm?.value?.hasRemainingValidationErrors ||
                    errorMessage != null
                        ? ': ' + errorMessage
                        : '.'
                }}
            </p>
        </div>
    </div>

    <button
        *ngIf="canEditMission"
        type="button"
        class="btn btn-default"
        (click)="showMissionEditDialogue.emit()"
        [disabled]="working || editStart || editEnd"
    >
        Edit Mission
    </button>

    <button
        *ngIf="canSubmit"
        type="button"
        class="btn btn-primary"
        (click)="requestAuthorisation.emit()"
        [disabled]="working || !formValid || errorMessage != null"
    >
        Request
        {{ authorisationPreview?.authorisationType | formatAuthorisationType }}
        Airspace Authorisation
    </button>

    <button
        type="button"
        class="btn btn-primary"
        (click)="close.emit()"
        [disabled]="working || editStart || editEnd"
    >
        Close
    </button>
</div>

<!-- ── NO PREVIEW footer ───────────────────────────────────────────────── -->
<div class="modal-footer" *ngIf="mode === 'NO_PREVIEW'">
    <div
        *ngIf="!working && errorMessage != null && errorMessage.length > 0"
        class="alert alert-danger footer-alert pull-left"
        role="alert"
    >
        {{ errorMessage }}
    </div>
    <p *ngIf="!working && (errorMessage == null || errorMessage.length === 0)">
        <span class="fa fa-times right-buffer"></span>
        Automated Authorisation Request could not be generated
    </p>
    <button
        *ngIf="canEditMission || approval"
        type="button"
        class="btn btn-default"
        (click)="showMissionEditDialogue.emit()"
        [disabled]="working || editStart || editEnd"
    >
        Edit Mission
    </button>
    <button
        type="button"
        class="btn btn-primary"
        (click)="close.emit()"
        [disabled]="working || editStart || editEnd"
    >
        Close
    </button>
</div>

<!-- ── ACTIVE / PENDING footer ─────────────────────────────────────────── -->
<div class="modal-footer" *ngIf="mode === 'ACTIVE'">
    <button
        type="button"
        class="btn btn-primary"
        (click)="close.emit()"
        [disabled]="working"
    >
        Acknowledge
    </button>

    <div
        *ngIf="
            !working && airspaceAuthorisationType === 'AUS_CASA_AUTHORISATION'
        "
        class="alert alert-success footer-alert pull-left"
        role="alert"
    >
        <p>
            <span class="fa fa-check right-buffer"></span>
            CASA Automated Authorisation Instrument Created ({{ approvedId }})
        </p>
    </div>

    <div
        *ngIf="
            !working &&
            airspaceAuthorisationType === 'NZL_AIRSHARE' &&
            (airspaceAuthorisationStatus === 'APPROVED' ||
                airspaceAuthorisationStatus === 'DECLARED')
        "
        class="alert alert-success footer-alert pull-left"
        role="alert"
    >
        <p>
            <span class="fa fa-check right-buffer"></span>
            AirShare Authorisation Request Approved ({{ approvedId }})
        </p>
    </div>

    <div
        *ngIf="
            !working &&
            airspaceAuthorisationType === 'NZL_AIRSHARE' &&
            airspaceAuthorisationStatus === 'PENDING'
        "
        class="alert alert-success footer-alert pull-left"
        role="alert"
    >
        <p>
            <span class="fa fa-check right-buffer"></span>
            AirShare Authorisation Request Pending Decision ({{ approvedId }})
        </p>
    </div>

    <div
        *ngIf="
            !working &&
            airspaceAuthorisationType === 'NZL_AIRSHARE' &&
            airspaceAuthorisationStatus === 'PROVISIONAL'
        "
        class="alert alert-success footer-alert pull-left"
        role="alert"
    >
        <p>
            <span class="fa fa-check right-buffer"></span>
            AirShare Authorisation Request Approved Provisionally ({{
                approvedId
            }})
        </p>
    </div>
</div>

<!-- ── COMPLETED / CLOSED footer ───────────────────────────────────────── -->
<div class="modal-footer" *ngIf="mode === 'COMPLETED'">
    <div
        *ngIf="
            !working && airspaceAuthorisationType === 'AUS_CASA_AUTHORISATION'
        "
        class="alert alert-success footer-alert pull-left"
        role="alert"
    >
        <p>CASA Automated Authorisation Instrument {{ approvedId }} Closed</p>
    </div>
    <div
        *ngIf="!working && airspaceAuthorisationType === 'NZL_AIRSHARE'"
        class="alert alert-success footer-alert pull-left"
        role="alert"
    >
        <p>Airshare Authorisation Request {{ approvedId }} Closed</p>
    </div>
    <button
        *ngIf="canEditMission"
        type="button"
        class="btn btn-default"
        (click)="showMissionEditDialogue.emit()"
        [disabled]="working || editStart || editEnd"
    >
        Edit Mission
    </button>
    <button
        type="button"
        class="btn btn-primary"
        (click)="close.emit()"
        [disabled]="working"
    >
        OK
    </button>
</div>

<!-- ── CANCELLED footer ─────────────────────────────────────────────────── -->
<div class="modal-footer" *ngIf="mode === 'CANCELLED'">
    <div
        *ngIf="
            !working && airspaceAuthorisationType === 'AUS_CASA_AUTHORISATION'
        "
        class="alert alert-danger footer-alert pull-left"
        role="alert"
    >
        <p>
            <span class="fa fa-times right-buffer"></span>
            Automated Authorisation Request Cancelled
            {{ approvedId ? '(' + approvedId + ')' : '' }}
        </p>
    </div>
    <div
        *ngIf="!working && airspaceAuthorisationType === 'NZL_AIRSHARE'"
        class="alert alert-danger footer-alert pull-left"
        role="alert"
    >
        <p>
            <span class="fa fa-times right-buffer"></span>
            Authorisation Request Cancelled
            {{ approvedId ? '(' + approvedId + ')' : '' }}
        </p>
    </div>
    <button
        *ngIf="canEditMission"
        type="button"
        class="btn btn-default"
        (click)="showMissionEditDialogue.emit()"
        [disabled]="working || editStart || editEnd"
    >
        Edit Mission
    </button>
</div>

<!-- ── REJECTED footer ──────────────────────────────────────────────────── -->
<div class="modal-footer" *ngIf="mode === 'REJECTED'">
    <div
        *ngIf="
            !working && airspaceAuthorisationType === 'AUS_CASA_AUTHORISATION'
        "
        class="alert alert-danger footer-alert pull-left"
        role="alert"
    >
        <p>
            <span class="fa fa-times right-buffer"></span>
            Automated Authorisation Request Rejected
            {{ approvedId ? '(' + approvedId + ')' : '' }}
        </p>
    </div>
    <div
        *ngIf="!working && airspaceAuthorisationType === 'NZL_AIRSHARE'"
        class="alert alert-danger footer-alert pull-left"
        role="alert"
    >
        <p>
            <span class="fa fa-times right-buffer"></span>
            Authorisation Request Rejected
            {{ approvedId ? '(' + approvedId + ')' : '' }}
        </p>
    </div>
    <button
        *ngIf="canEditMission"
        type="button"
        class="btn btn-default"
        (click)="showMissionEditDialogue.emit()"
        [disabled]="working || editStart || editEnd"
    >
        Edit Mission
    </button>
</div>
